<script setup lang="ts">
import type { CartItem } from "@/schemas/cart";

const props = defineProps<{ cartItem: CartItem }>();
const { onUpdateCartItem, isDisabled } = useUpdateCartItem();
const quantity = computed<number>({
  get: () => props.cartItem.quantity,
  set: (newQuantity) => {
    onUpdateCartItem({ cart_item_key: props.cartItem.key, quantity: newQuantity });
  },
});
</script>

<template>
  <InputQuantity v-model="quantity" :disabled="isDisabled" :max="cartItem.stock_level" />
</template>
